// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"11c63fb9","112":"37c27e98","535":"002a371b","547":"3fd91c2b","551":"8b1110b9","553":"a87e97fe","575":"4a29a7d9","881":"fea6151e"}[chunkId] + ".chunk.js";
};